import { render, staticRenderFns } from "./MediateDirector.vue?vue&type=template&id=55f8d4bd&"
import script from "./MediateDirector.vue?vue&type=script&lang=js&"
export * from "./MediateDirector.vue?vue&type=script&lang=js&"
import style0 from "./MediateDirector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports